import { makeStyles } from '@material-ui/core'
import React, {useState} from 'react'
import { notification } from 'antd'
import {Drawer, Input, Form, Select} from 'antd'
import { CTAButton } from '../../components'
import { useData } from '../../../../data'
import { trackPromise, usePromiseTracker } from 'react-promise-tracker'

const useStyles = makeStyles(theme => ({
    error: {
        fontSize: 18,
        color: 'red'
    }
}))

const {Option} = Select

const NewTitleVariation = ({visible, close}) => {
    const [error, setError] = useState(null)
    const classes = useStyles()
    const [form] = Form.useForm()
    const data = useData()
    const titles = data.titles()

    const createTitleVariation = vals => {

        trackPromise(
            titles.createVariation(vals)
            .then((msg)=>{
                close()
                notification.success({
                    message: "Title variation created successfully."
                })
            })
                .catch(err => {
                    console.log(err);
                    if('detail' in err){
                        setError(err)
                    }
                    setError("An error occured.")
                    notification.error({
                        message: err.toString()
                    })
                })
        )
    }

    const {promiseInProgress} = usePromiseTracker()
    
    return (
        <Drawer
            visible={visible}
            onClose={close}
            placement="right"
            closable={true}
            width={350}
            title="Create a title variation"
        >
            <Form
                layout="vertical"
                onFinish={createTitleVariation}
                form={form}
            >
                <Form.Item label="Initial" name="initial" placeholder="initial" rules={[{required: true, message: 'Initial is required'}]}>
                    <Input />
                </Form.Item>
                <Form.Item name='variations' label="Variations">
                    <Input.TextArea placeholder="Variations" />
                </Form.Item>

                <Form.Item>
                    <CTAButton loading={promiseInProgress} type="submit"><>Submit</></CTAButton>
                </Form.Item>
                {
                    error && (
                        <Form.Item>
                            <p className={classes.error}>{error}</p>
                        </Form.Item>
                    )
                }

            </Form>
        </Drawer>
    )
}

export default NewTitleVariation
